import {
    EDIT_COURIER_REQUEST,
    EDIT_COURIER_SUCCESS,
    EDIT_COURIER_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const editCourierListByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_COURIER_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case EDIT_COURIER_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case EDIT_COURIER_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default editCourierListByAdminReducer;
